import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Virtual } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import './index.scss';
import Slide from './Slide';
import music from 'asset/img/laba.png';
import musicClose from 'asset/img/laba-close.png';
import yingshi2Img from 'asset/img/yingshi2.png';
// import main from 'asset/music/main.mp3';
import star from 'asset/img/star-top.png';
import { useLocation, useNavigate } from 'react-router-dom';
import ControlCenter from 'components/ControlCenter/index';
import { getCourseList, getUserInfo, getCheckinStatus, checkinDailyPopupSeen } from 'network/index';
import { useDispatch, useSelector } from 'react-redux';
import Loadding from 'components/Loadding';
import DailyLoginModal from 'components/DailyLoginModal';
import { setUser } from 'actions';

// 【调试】首次登录 Loadding 常开，调试完改回 false
const DEBUG_FIRST_LOGIN = false;

const Home = () => {
  const location = useLocation();
  const swiperRef = useRef(null);
  const [allImagesLoaded, setAllImagesLoaded] = useState(false);
  // 首次登录 Loadding：必须首帧就确定是否展示，否则会出现短暂黑屏/闪屏
  const initialFirstLogin = (() => {
    if (DEBUG_FIRST_LOGIN) return true;
    try {
      return sessionStorage.getItem('first_login_loading') === '1';
    } catch (e) {
      return false;
    }
  })();
  const [firstLoginLoading, setFirstLoginLoading] = useState(initialFirstLogin);
  const [firstLoginMinDone, setFirstLoginMinDone] = useState(!initialFirstLogin);
  const [isAdmin, setIsAdmin] = useState(false);
  const dispatch = useDispatch();
  const reduxUser = useSelector((state) => state.user?.user || null);
  let navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [controlCenterOpen, setControlCenterOpen] = useState(false);
  const [musicStatus, setMusicStatus] = useState(true);
  const [starNumber, setStarNumber] = useState(0);
  const [list, setList] = useState([]);
  const [index, setIndex] = useState('');
  // 每日登录弹窗：仅当日首次进入 Home 时展示
  const [dailyLoginVisible, setDailyLoginVisible] = useState(false);
  const [dailyLoginPayload, setDailyLoginPayload] = useState({ variant: 'first', streak: 0, showMakeupButton: false, monthSigned: [] });

  // 首次登录：在 Home 内显示“生成关卡 Loadding”，并消费 sessionStorage 标记
  useEffect(() => {
    if (DEBUG_FIRST_LOGIN) return; // 调试时跳过关闭逻辑
    if (!initialFirstLogin) return;
    // 进入后立即清掉标记，避免返回/刷新重复触发
    sessionStorage.removeItem('first_login_loading');
    const minTimer = setTimeout(() => setFirstLoginMinDone(true), 5600); // 2 张卡片 × 2.8s
    const maxTimer = setTimeout(() => setFirstLoginLoading(false), 20000); // 兜底：最多 20s
    return () => {
      clearTimeout(minTimer);
      clearTimeout(maxTimer);
    };
  }, []);

  // 首次登录 loadding：满足最小时长且首屏资源加载完成后再关闭（避免消失后短暂空白）
  useEffect(() => {
    if (DEBUG_FIRST_LOGIN) return; // 调试时跳过关闭逻辑
    if (!firstLoginLoading) return;
    if (firstLoginMinDone && allImagesLoaded) {
      setFirstLoginLoading(false);
    }
  }, [firstLoginLoading, firstLoginMinDone, allImagesLoaded]);

  // 【仅本地测试】URL 带 debug_daily_popup=1 时强制弹出每日登录弹窗，不改动正常显示逻辑
  const debugDailyPopup = typeof window !== 'undefined' && new URLSearchParams(location.search || '').get('debug_daily_popup') === '1';
  useEffect(() => {
    if (!debugDailyPopup || firstLoginLoading) return;
    const t = setTimeout(() => {
      setDailyLoginPayload({ variant: 'first', streak: 0, showMakeupButton: false, monthSigned: [] });
      setDailyLoginVisible(true);
    }, 800);
    return () => clearTimeout(t);
  }, [debugDailyPopup, firstLoginLoading]);

  // 每日登录弹窗：等首次登录 AI loadding 结束后再拉取并弹出；是否展示由接口 show_daily_popup 决定
  useEffect(() => {
    if (firstLoginLoading || debugDailyPopup) return; // 本地测试时用 URL 参数控制，不走接口
    const t = setTimeout(() => {
      getCheckinStatus({})
        .then((res) => {
          if (res?.code !== 0 || !res?.data) return;
          if (!res.data.show_daily_popup) return;
          const d = res.data;
          const totalDays = d.total_days ?? 0;
          const streak = d.streak ?? 0;
          const todaySigned = d.today_signed ?? false;
          const makeupLeft = d.makeup_left ?? 0;
          const canMakeupDates = d.can_makeup_dates ?? [];

          const firstDay = totalDays <= 1;
          const yesterdaySigned = streak >= 2 || (streak === 1 && !todaySigned);
          const showMakeupButton = !yesterdaySigned && makeupLeft > 0 && canMakeupDates.length > 0;

          let variant = 'encourage';
          if (firstDay) variant = 'first';
          else if (yesterdaySigned) variant = 'streak';

          const monthSigned = d.month_signed ?? [];
          setDailyLoginPayload({ variant, streak, showMakeupButton, monthSigned });
          setDailyLoginVisible(true);
        })
        .catch(() => {});
    }, 600);
    return () => clearTimeout(t);
  }, [firstLoginLoading]);

  const handleDailyLoginClose = useCallback(() => {
    setDailyLoginVisible(false);
    checkinDailyPopupSeen({}).catch(() => {});
  }, []);

  const handleSlideChange = (swiper) => {
    // 切换轮播时，切换对应的音乐
    // 安全获取当前索引
    try {
      // 优先使用 activeIndex，如果没有则使用 realIndex
      let currentIndex = 0;
      if (swiper?.activeIndex !== undefined && swiper.activeIndex !== null) {
        currentIndex = swiper.activeIndex;
      } else if (swiper?.realIndex !== undefined && swiper.realIndex !== null) {
        currentIndex = swiper.realIndex;
      }
      
      // 确保索引在有效范围内
      if (currentIndex >= 0 && currentIndex <= 2) {
        setCurrentSlide(currentIndex);
      }
    } catch (err) {
      console.warn('获取swiper索引失败:', err);
    }
    
  };

  const handleImagesLoaded = () => {
    setAllImagesLoaded(true);
  };

  useEffect(() => {
    let music = localStorage.getItem('music');
    music = JSON.parse(music);
    if (music === null) {
      music = true;
      localStorage.setItem('music', music);
    }
    setMusicStatus(music);
  }, []);

  useEffect(() => {
    let isMounted = true; // 防止组件卸载后更新状态

    const runWithUserData = (data) => {
      if (!data || !isMounted) return;
      let permssion;
      if (data.area) {
        try {
          permssion = JSON.parse(data.area);
        } catch (e) {
          console.error("解析失败:", e);
        }
      } else {
        permssion = [];
      }
      // setIsAdmin(data?.vip_expire == 111);
      dispatch(setUser(data));
      if (!data?.total_score) {
        setStarNumber(0);
      } else {
        setStarNumber(data.total_score);
      }

      getCourseList({}).then(response => {
        if (!isMounted) return;
        
        function updateIndex(arr) {
          for (let i = 0; i < arr.length - 1; i++) {
            if (arr[i].status === true && arr[i + 1].status === false) {
              return i;
            }
          }
        }

        function updateList(arr) {
          for (let i = 1; i < arr.length; i++) {
            const inPerm = Array.isArray(permssion) && permssion.some((p) => Number(p) === Number(arr[i].serial_id));
            if (arr[i - 1].curr_step >= 500 || inPerm) {
              arr[i]['status'] = true;
            } else {
              arr[i]['status'] = false;
            }
          }
          arr[0]['status'] = true;
          return arr;
        }
        // 箭头：指向「当前正在闯的关」= area 在顺序里最后一项（如 [7,10,11]→11）；无 area 则用最后一个 status 为 true 的
        const ORDERED_SERIALS = [7, 10, 11, 12, 13, 14, 15, 20, 21, 22, 23, 24];
        function arrowList(arr) {
          if (!arr || arr.length === 0) return arr;
          arr.forEach((item) => { item.arrow = false; });
          const permArr = Array.isArray(permssion) ? permssion : [];
          const hasArea = permArr.length > 0;
          if (hasArea) {
            const lastIdx = Math.max(-1, ...permArr.map((s) => ORDERED_SERIALS.indexOf(Number(s))).filter((i) => i >= 0));
            const targetSerial = lastIdx >= 0 ? ORDERED_SERIALS[lastIdx] : ORDERED_SERIALS[0];
            const targetItem = arr.find((item) => Number(item.serial_id) === targetSerial);
            if (targetItem) targetItem.arrow = true;
          } else {
            let lastTrueIndex = -1;
            for (let i = 0; i < arr.length; i++) {
              if (arr[i].status === true) lastTrueIndex = i;
            }
            if (lastTrueIndex !== -1) arr[lastTrueIndex].arrow = true;
          }
          return arr;
        }
        const _list = updateList(response?.data?.course_list);
        const list = arrowList(_list)
        
        const index = updateIndex(list);
        setList(list)
        setIndex(index)
      }).catch(error => {
        console.error(error);
      });
    };

    // 每次进入 Home 都拉最新用户信息（含 area），避免测评等流程更新 area 后，关卡开关不刷新
    getUserInfo({}).then((res) => {
      if (!isMounted) return;
      runWithUserData(res?.data);
    }).catch(() => {
      if (!isMounted) return;
      if (reduxUser) runWithUserData(reduxUser);
    });

    // 返回主菜单，定位到原先的页面 
    const searchParams = new URLSearchParams(location.search);
    const type = searchParams.get('type');
    if (swiperRef.current?.swiper && type) {
      const targetIndex = parseInt(type, 10);
      if (!isNaN(targetIndex) && targetIndex >= 0 && targetIndex <= 2) {
        swiperRef.current.swiper.slideTo(targetIndex, 0, false);
        // 同步更新分页指示器状态
        setCurrentSlide(targetIndex);
      }
    } else if (swiperRef.current?.swiper) {
      // 如果没有type参数，确保分页指示器与当前Swiper状态同步
      const currentIndex = swiperRef.current.swiper.activeIndex ?? 0;
      if (currentIndex >= 0 && currentIndex <= 2) {
        setCurrentSlide(currentIndex);
      }
    }
    
    return () => {
      isMounted = false;
      if (swiperRef.current?.swiper) {
        swiperRef.current.swiper.destroy(true, true);
      }
    };
  }, []);
  
  // 监听location变化，确保从其他页面返回时正确更新分页指示器
  useEffect(() => {
    if (!swiperRef.current?.swiper) return;
    
    const searchParams = new URLSearchParams(location.search);
    const type = searchParams.get('type');
    
    if (type) {
      const targetIndex = parseInt(type, 10);
      if (!isNaN(targetIndex) && targetIndex >= 0 && targetIndex <= 2) {
        // 延迟执行，确保Swiper已完全初始化
        const timer = setTimeout(() => {
          if (swiperRef.current?.swiper) {
            const currentIndex = swiperRef.current.swiper.activeIndex ?? 0;
            if (currentIndex !== targetIndex) {
              swiperRef.current.swiper.slideTo(targetIndex, 0, false);
            }
            setCurrentSlide(targetIndex);
          }
        }, 50);
        
        return () => clearTimeout(timer);
      }
    } else {
      // 没有type参数时，同步当前Swiper状态
      const currentIndex = swiperRef.current.swiper.activeIndex ?? 0;
      if (currentIndex >= 0 && currentIndex <= 2) {
        setCurrentSlide(currentIndex);
      }
    }
  }, [location.search]);

  const openMusic = () => {
    let value = localStorage.getItem('music');
    if (value !== null && value !== undefined) {
      try {
        value = JSON.parse(value);
        setMusicStatus(!value);
        localStorage.setItem('music', !value);
        window.dispatchEvent(new CustomEvent('home-music-toggle'));
      } catch (err) {
        console.log(err, 'err');
      }
    }
  };

  return (
    <div className='home-container'>
      <Swiper
        ref={swiperRef}
        modules={[Virtual]}
        spaceBetween={0}
        onSlideChange={handleSlideChange}
        onSwiper={(swiper) => {
          // 初始化时设置当前索引
          if (swiper) {
            const initialIndex = swiper.activeIndex ?? 0;
            setCurrentSlide(initialIndex);
            
            // 如果URL中有type参数，延迟设置以确保Swiper已完全初始化
            const searchParams = new URLSearchParams(location.search);
            const type = searchParams.get('type');
            if (type) {
              const targetIndex = parseInt(type, 10);
              if (!isNaN(targetIndex) && targetIndex >= 0 && targetIndex <= 2) {
                setTimeout(() => {
                  if (swiperRef.current?.swiper) {
                    swiperRef.current.swiper.slideTo(targetIndex, 0, false);
                    setCurrentSlide(targetIndex);
                  }
                }, 100);
              }
            }
          }
        }}
        loop={false}
        resistanceRatio={0}
        // true 会在边缘把触摸交给外层并临时 touch-action:auto，易与内层纵向滚动叠加出橡皮筋
        touchReleaseOnEdges={false}
        // 横滑 Swiper + 每页内纵向滚动：用 nested 让触摸在捕获阶段更好分流（Swiper 官方场景）
        nested
        direction="horizontal"
        virtual={{
          enabled: true,
          addSlidesAfter: 0,
          addSlidesBefore: 0,
        }}
      >
        {[0, 1, 2].map((type) => (
          <SwiperSlide key={type} className='home-item' virtualIndex={type}>
            <Slide
              type={type}
              list={list.slice(type * 4, type * 4 + 4)}
              index={index}
              onImagesLoaded={handleImagesLoaded}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <div
        className="home-yingshi-entry"
        onClick={() => navigate('/yingshi', { state: { list, index } })}
        role="button"
        tabIndex={0}
        aria-label="雷音寺"
      >
        <span className="yingshi-entry-icon">
          <img src={yingshi2Img} alt="" loading="lazy" decoding="async" />
        </span>
        <span className="yingshi-entry-text">雷音寺</span>
      </div>
      <ControlCenter onVisibilityChange={setControlCenterOpen} />
      {/* 育儿顾问入口：先隐藏，后续可去掉 home-parenthelp-entry-hidden-always 恢复 */}
      <div
        className={`home-parenthelp-entry home-parenthelp-entry-hidden-always${controlCenterOpen ? ' home-checkin-entry-hidden' : ''}`}
        onClick={() => navigate('/parentHelp')}
        role="button"
        tabIndex={0}
        aria-label="育儿顾问"
      >
        <span className="parenthelp-icon-wrap">
          <svg className="parenthelp-icon" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="2" width="30" height="22" rx="5" fill="#FFF8E1" stroke="#F5A623" strokeWidth="1.8"/>
            <path d="M14 8v14l12-7-12-7z" fill="#E65100"/>
            <circle cx="18" cy="28" r="3" fill="#FFB74D" stroke="#F5A623" strokeWidth="1"/>
          </svg>
        </span>
        <span className="parenthelp-text">育儿顾问</span>
      </div>
      <div
        className={`home-checkin-entry${controlCenterOpen ? ' home-checkin-entry-hidden' : ''}`}
        onClick={() => navigate('/checkin')}
      >
        <span className="checkin-emoji">📅</span>
        <span className="checkin-text">每日打卡</span>
      </div>
      {musicStatus ? <img src={music} className='music music-on' onClick={openMusic} />
        :
        <img src={musicClose} className='music music-off' onClick={openMusic} />}
      <div className='star'>
        <img src={star} />
        <div className='starNumber'>{starNumber}</div>
      </div>
      {/* 分页指示器 - 童趣风格 */}
      <div className='home-pagination'>
        {[0, 1, 2].map((index) => (
          <div
            key={index}
            className={`pagination-dot ${currentSlide === index ? 'active' : ''}`}
            onClick={() => {
              if (swiperRef.current?.swiper) {
                swiperRef.current.swiper.slideTo(index);
              }
            }}
          >
            <span className='dot-emoji'>{currentSlide === index ? '⭐' : '✨'}</span>
          </div>
        ))}
      </div>
      {firstLoginLoading ? (
        <Loadding visible variant="first_login" />
      ) : (
        allImagesLoaded ? null : <Loadding />
      )}
      <DailyLoginModal
        visible={dailyLoginVisible}
        onClose={handleDailyLoginClose}
        variant={dailyLoginPayload.variant}
        streak={dailyLoginPayload.streak}
        showMakeupButton={dailyLoginPayload.showMakeupButton}
        monthSigned={dailyLoginPayload.monthSigned}
        onMakeupClick={() => { handleDailyLoginClose(); navigate('/checkin'); }}
      />
    </div>
  );
};

export default Home;